import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CHECKOUT_URL } from '../data/content';
import { trackInitiateCheckout } from '../utils/metaPixel';

/**
 * Sticky bottom bar that appears once the user scrolls past the hero CTA.
 */
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('hero-cta');
    if (!anchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      setVisible(entry.boundingClientRect.top < 0 && !entry.isIntersecting);
    }, {
      threshold: 0
    });
    observer.observe(anchor);
    return () => observer.disconnect();
  }, []);
  return <AnimatePresence data-id="element-119" data-mp="bpzqn6mg58wn">
      {visible && <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 320,
      damping: 30
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-navy-950/95 px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur" data-id="element-120" data-mp="1966il0vt9yfn">
          <div className="mx-auto flex max-w-2xl flex-col items-center gap-2" data-id="element-121" data-mp="2f656903iu8tm">
            <a href={CHECKOUT_URL} onClick={trackInitiateCheckout} className="flex w-full items-center justify-center rounded-xl bg-violet-500 px-4 py-3.5 text-center text-[13px] font-extrabold uppercase tracking-wide text-white transition-colors hover:bg-violet-400 sm:text-base" data-id="element-122" data-mp="21cdsffirc2s3">
              Quiero la Ruta por USD 15
            </a>
            <p className="text-[10px] font-medium text-white/60 sm:text-xs" data-id="element-123" data-mp="1ifcn1tlak0nm">
              Pago único · Acceso de por vida · Garantía 7 días
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}